import { create } from 'zustand'

interface User {
  id: string
  email: string
  org_id: string
  role: 'admin' | 'member'
  status: 'pending' | 'approved' | 'suspended'
}

export interface Project {
  id: string
  name: string
  description?: string
  created_by?: string
  created_by_name?: string
  target_system?: string
  connection_name?: string
  connection_type?: string
  saviynt_url?: string
  saviynt_username?: string
  secret_count?: number  // Number of project secrets configured (values never stored in frontend)
  has_saviynt_username_secret?: boolean
  has_saviynt_password_secret?: boolean
  status?: string
  created_at?: string
  updated_at?: string
  connection_count?: number
  conversation_count?: number
  active_conversation_count?: number
  connection_summaries?: Array<{ name: string; connector_family: string }>
  connection_names?: string[]
  connector_families?: string[]
  connection_status_counts?: Record<string, number>
  last_activity_at?: string
}

interface AppState {
  user: User | null
  accessToken: string | null  // Short-lived JWT stored in memory only (never localStorage)
  currentProject: Project | null
  projects: Project[]

  setAuth: (user: User) => void
  clearAuth: () => void
  setAccessToken: (token: string) => void
  clearAccessToken: () => void
  setCurrentProject: (p: Project) => void
  setProjects: (ps: Project[]) => void
  updateProject: (updates: Partial<Project>) => void
}

export const useStore = create<AppState>((set) => ({
  user: null,
  accessToken: null,
  currentProject: null,
  projects: [],

  setAuth: (user) => set({ user }),

  clearAuth: () => {
    set({ user: null, accessToken: null, currentProject: null, projects: [] })
    window.location.href = '/login'
  },

  setAccessToken: (token) => set({ accessToken: token }),

  clearAccessToken: () => set({ accessToken: null }),

  setCurrentProject: (p) => set({ currentProject: p }),
  setProjects: (ps) => set({ projects: ps }),
  updateProject: (updates) =>
    set((state) => ({
      currentProject: state.currentProject
        ? { ...state.currentProject, ...updates }
        : null,
    })),
}))
